"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  color: initial;\n  background-color: initial;\n  font-size: 1.5rem;\n\n  &:first-child {\n    color: initial;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  border-bottom: 3px solid ", ";\n  color: ", ";\n  overflow: hidden;\n\n  &:last-child {\n    border-bottom: none;\n    border-bottom-style: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.tr(_templateObject(), _Constant.Color.WHITE, _Constant.Color.DARK_GREY);

var TableColumn = _styledComponents.default.td(_templateObject2());

var TableRow = function TableRow(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, data.map(function (d) {
    return /*#__PURE__*/_react.default.createElement(TableColumn, {
      key: d,
      style: {
        width: "".concat(1 / data.length * 100, "%")
      }
    }, d);
  }));
};

TableRow.propTypes = {
  /** A list of nodes to render within the row (they will be wrapped in a <td />) */
  data: _propTypes.default.arrayOf(_propTypes.default.node).isRequired
};
var _default = TableRow;
exports.default = _default;